import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Demo, {
  DemoSliderControl,
  DemoRadioControl,
} from '@/components/Demo';

import Snippet from './Snippet';
import OutputWrapper from './OutputWrapper';

function PxRemComparisonDemo() {
  return (
    <Demo
      id="px-rem-comp-demo"
      initialValues={{
        fontSize: 100,
        unit: 'rem',
      }}
      outputWrapper={OutputWrapper}
      controls={[
        <DemoSliderControl
          key="fontSize"
          id="fontSize"
          label="Default font size"
          min={80}
          max={200}
          previewRenderer={(val) => `${val}%`}
        />,
        <DemoRadioControl
          key="unit"
          id="unit"
          label="Font unit"
          options={['rem', 'px']}
        />,
      ]}
      controlPosition="top"
    >
      {({ fontSize, unit }) => {
        const appliedFontSize =
          unit === 'px' ? '1rem' : fontSize / 100 + 'rem';

        return (
          <OuterWrapper>
            <Wrapper style={{ fontSize: appliedFontSize }}>
              <p>This is a paragraph with some words and things.</p>
            </Wrapper>

            <Snippet
              code={generateCodeSnippet({ unit })}
              minCodeHeight="7.875rem"
            />
          </OuterWrapper>
        );
      }}
    </Demo>
  );
}

function generateCodeSnippet({ unit }: { unit: 'px' | 'rem' }) {
  return `
p {
  font-size: ${unit === 'px' ? '16px' : '1rem'};
}`;
}

const OuterWrapper = styled.div`
  width: 100%;
`;

const Wrapper = styled.div`
  padding: 16px;
  margin-bottom: 1rem;

  @media ${BREAKPOINTS.smAndLarger} {
    padding: 32px;
    margin-bottom: 0;
  }
`;

export default PxRemComparisonDemo;
